import { partialRepaymentOutput } from './../services/PartialRepaymentCalc';
import { getLtvValue } from './../services/LtvCalc';

const defaultInput = {
  clientAge: 55,
  loanTaken: 50000,  //
  interestTaken: 4.00, // aka loanAPR, 3..8%
  housePrice: 1000000,  // G6
  futureHousePricePct: 2, // G13, -1%.. 1%, step 0.25
  repaymentPeriod: 'monthly',
  currentRepayments: 1,
  currentDrawdowns: 1,
  capitalValue1: 0,
  stopPartialRepayment1: 10, // stop after N years
  max1: false,
  interest1: true,
  capitalValue2: 0,
  stopPartialRepayment2: 5, // stop after N years
  max2: false,
  interest2: false,
  capitalValue3: 0,
  stopPartialRepayment3: 2, // stop after N years
  max3: false,
  interest3: false,
  stopPayingOffInterest: 5,
  period: 12, // yearly
  ltvPlan: '',
  isJoint: false, // single or joint
  stage: 1,
  reportGenerating: false,
  drawdownValue1: 0,
  drawdownYear1: 5,
  drawdownValue2: 0,
  drawdownYear2: 5,
  drawdownValue3: 0,
  drawdownYear3: 5,
  showNoRepayments: true,
  showRepayments: true,
  showDrawdown: true,
  displayForm: false,
  displayFormComplete: false,
  formName: "",
  formEmail: "",
  formCompany: "",
  formCaseNumber: "",
  formMessage: "",
  formPrivacyAgree: false,
  privacyError: false,
  adHocFormVisible: false,
  adHocEnabled: false,
  adHocDrawdown: {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
    8: 0,
    9: 0,
    10: 0,
    11: 0,
    12: 0,
    13: 0,
    14: 0,
    15: 0,
    16: 0,
    17: 0,
    18: 0,
    19: 0,
    20: 0,
    21: 0,
    22: 0,
    23: 0,
    24: 0,
    25: 0,
  },
  adHocPayments: {
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
    8: 0,
    9: 0,
    10: 0,
    11: 0,
    12: 0,
    13: 0,
    14: 0,
    15: 0,
    16: 0,
    17: 0,
    18: 0,
    19: 0,
    20: 0,
    21: 0,
    22: 0,
    23: 0,
    24: 0,
    25: 0,
  }
};

const yearlyCapitalValue = ({ period, capitalValue }) => {
  return (12.0 / period) * parseInt(capitalValue, 10)
};


const updateInputOutput = ({ input, output }) => {
  const validLoan = !isNaN(input.loanTaken) && parseInt(input.loanTaken,10) > 0
  const validCapitalValue = !isNaN(input.capitalValue) && parseInt(input.capitalValue,10) > 0;
  output.yearlyCapitalValue = yearlyCapitalValue(input)
  output.maxYearlyLoan = parseInt(input.loanTaken * 0.1, 10);

  if (validLoan && validCapitalValue && output.maxStopAfter > 0) {
    const hasError = output.yearlyCapitalValue > output.maxYearlyLoan;
    if (!hasError && input.stopPartialRepayment > output.maxStopAfter) {
      input.stopPartialRepayment = output.maxStopAfter;
    }
  }
  if (input.clientAge < 55) {
    input.clientAge = 55;
  }
  // if (input.clientAge === 55 && input.isJoint) {
  //   input.clientAge = 56;
  // }

  output.ltv = getLtvValue(input);
  output.hideChart = !validLoan || !validCapitalValue || (input.loanTaken > output.ltv.max) ||
    (output.yearlyCapitalValue > output.maxYearlyLoan);
  return { input, output };
};

const output = partialRepaymentOutput(defaultInput);
const initialState = updateInputOutput({ input: defaultInput, output });

export default function (state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_INPUT': {
      const {field, value} = action.payload;
      const input = { ...state.input, [field] : value };
      const output = partialRepaymentOutput(input);
      updateInputOutput({ input, output });
      return { ...state, input, output};
    }
    case 'UPDATE_PLAN': {
      const input = { ...state.input };
      input.ltvPlan = action.payload;
      const output = partialRepaymentOutput(input);
      updateInputOutput({ input, output });
      return { ...state, input, output};
    }
    default:
  }
  return state
};



// WEBPACK FOOTER //
// ./src/reducers/partialRepayment.js